import { render, staticRenderFns } from "./AlertsView.vue?vue&type=template&id=f3b5d97c&lang=pug&"
import script from "./AlertsView.vue?vue&type=script&lang=ts&"
export * from "./AlertsView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports